"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsReactQueryProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactQuery = require("react-query");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsReactQueryProvider = _ref => {
  let {
    children
  } = _ref;
  const queryClient_ = new _reactQuery.QueryClient();
  return /*#__PURE__*/_react.default.createElement(_reactQuery.QueryClientProvider, {
    client: queryClient_
  }, children);
};
exports.DmsReactQueryProvider = DmsReactQueryProvider;